'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postStopTrackScrollPercentage = undefined;

var _createPostMessageAction = require('../../post-message/actions/createPostMessageAction');

var _PostMessageTypes = require('../../constants/PostMessageTypes');

var postStopTrackScrollPercentage = exports.postStopTrackScrollPercentage = (0, _createPostMessageAction.createPostMessageAction)(_PostMessageTypes.STOP_TRACK_SCROLL_PERCENTAGE);